import React, { Component } from 'react';
//import { connectHits } from 'react-instantsearch/dom';
import { Grid, } from 'semantic-ui-react'
import ImageView from '../ImageFinder/ImageView'

// const CustomHits = ({ hits }) => (
//   <ol>
//     {hits.map(hit => (
//       <li key={hit.objectID}>{hit.name}</li>
//     ))}
//   </ol>
// );

class ImageSearchCustomHit extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {
        //console.log("csxt1:mainCardObjects" + this.props.mainCardObjects.length);
    }

    render() {
        const hitsUI = this.props.hits.map(hit =>
            <Grid.Column>
                <ImageView
                    //user={this.state.userFromFirebaseNode}
                    // user={user}
                    imageObject={hit} />

            </Grid.Column>
        )

        return <div style={{ marginTop: '10px' }}>
            <Grid stackable columns={4}>
                {hitsUI}
            </Grid>


        </div>
    }
}

//const ConnectedCustomHit = connectHits(CustomHits);
//export default connectHits(CustomHits);
export default ImageSearchCustomHit;

//export const chits = connectHits(CustomHits);


// WEBPACK FOOTER //
// ./src/components/newSite/ImageFinder/ImageSearchCustomHit.js